import React from 'react';
import { TrustBar } from './TrustBar';
import { Services } from './Services';
import { Safety } from './Safety';
import { Availability } from './Availability';
import { RepairVsReplace } from './RepairVsReplace';
import { SideRearGlass } from './SideRearGlass';
import { Insurance } from './Insurance';
import { Adas } from './Adas';
import { QuoteProcess } from './QuoteProcess';
import { WhyChoose } from './WhyChoose';
import { ServiceArea } from './ServiceArea';
import { EmergencyAutoGlassFAQ } from '../../components/EmergencyAutoGlassFAQ/EmergencyAutoGlassFAQ';
import { ServiceReview } from '../../../components/PageIntro';
export function EmergencyAutoGlass() {
  return <div className="legacy-sections" data-id="element-945" data-mp="2od9fh98bdv1s">
<TrustBar data-id="element-946" data-mp="2tdnr1194jn4k" />
<Services data-id="element-947" data-mp="2tf8lkqvfv62f" />
<ServiceReview index={0} data-id="element-948" data-mp="2teytmxqu2ou3" />
<Safety data-id="element-949" data-mp="2tc2vb8b2py54" />
<Availability data-id="element-950" data-mp="2tbuh9d37smsc" />
<RepairVsReplace data-id="element-951" data-mp="2feedyag7t94t" />
<SideRearGlass data-id="element-952" data-mp="2fdw8qobkrkkr" />
<Insurance data-id="element-953" data-mp="2ffh1c8ebwtfz" />
<Adas data-id="element-954" data-mp="2fextxlmb1ng7" />
<QuoteProcess data-id="element-955" data-mp="2ff7l3cj360nh" />
<WhyChoose data-id="element-956" data-mp="2fgimj5p26wbf" />
<ServiceArea data-id="element-957" data-mp="2jfzuq6vve7ka" />
<EmergencyAutoGlassFAQ data-id="element-958" data-mp="2jfrh2crxay81" />
</div>;
}